import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ToastService } from 'src/app/modules/shared/services/toast/toast.service';

/**
 * PBI 102993 — modal para capturar o "Motivo do bloqueio" (área de texto, texto longo)
 * quando a transição de status leva o veículo/movimentação ao status "Bloqueado".
 * Espelha o ModalMotivoRecusaComponent (PBI 95605), com wording e limite próprios.
 */
@Component({
  selector: 'app-modal-motivo-bloqueio',
  templateUrl: './modal-motivo-bloqueio.component.html',
  styleUrls: ['./modal-motivo-bloqueio.component.scss'],
})
export class ModalMotivoBloqueioComponent {
  form: FormGroup;

  // "Texto longo" (PBI): limite generoso, alinhado à recomendação do contrato.
  readonly maxLength = 1000;

  constructor(
    private fb: FormBuilder,
    private toastService: ToastService,
    private modalCtrl: ModalController,
  ) {
    this.form = this.fb.group({
      // Validators.required + noWhitespace cobrem "campo vazio" e "somente espaços".
      motivo: [
        null,
        [
          Validators.required,
          Validators.maxLength(this.maxLength),
          this.noWhitespaceValidator,
        ],
      ],
    });
  }

  private noWhitespaceValidator(control: { value: string | null }) {
    const value = control.value ?? '';
    return value.trim().length === 0 ? { whitespace: true } : null;
  }

  getFormControl(controlName: string) {
    return this.form.get(controlName);
  }

  close() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return this.toastService.showError(
        'Informe o motivo do bloqueio para continuar',
      );
    }

    return this.modalCtrl.dismiss(this.form.value.motivo.trim(), 'confirm');
  }
}
